import {
  arrayOf, bool, func, shape,
} from 'prop-types';
import React, { Fragment, PureComponent } from 'react';
import { View } from 'react-native';

import { FORMS, STYLE, C } from 'common';
import { Button, Dialog, Form } from 'reactor/components';
import { Consumer } from 'context';

class DialogStory extends PureComponent {
  static propTypes = {
    dataSource: shape({}),
    onClose: func,
    stories: arrayOf(shape({})),
    visible: bool.isRequired,
  };

  static defaultProps = {
    dataSource: {},
    onClose: undefined,
    stories: [],
  };

  constructor(props) {
    super(props);
    this.state = { dataSource: props.dataSource, busy: false, valid: true };
  }

  componentWillReceiveProps({ dataSource }) {
    this.setState({ busy: false, dataSource, valid: false });
  }

  _onFormChange = dataSource => this.setState({ dataSource })

  _onFormValid = valid => this.setState({ valid })

  _onSubmit = async (method, onError) => {
    const { props: { onClose }, state: { dataSource } } = this;
    const service = dataSource.id ? `story/${dataSource.id}` : 'story';
    this.setState({ busy: true });
    await fetch({ method, service, props: { dataSource } }).catch(onError);
    this.setState({ busy: false });
    onClose();
  };

  render() {
    const {
      _onFormChange, _onFormValid, _onSubmit,
      props: { stories, ...props },
      state: { busy, dataSource = {}, valid },
    } = this;
    const { id } = dataSource;
    const isBusy = busy ? { activity: true, disabled: true } : {};

    // -------------------------------------------------------------------------
    // @TODO: Find a much cleaner pattern (maybe create a copy of FORMS.STORY)
    FORMS.STORY.related.dataSource = stories;
    // -------------------------------------------------------------------------

    return (
      <Consumer>
        { ({ l10n = {} }) => (
          <Dialog {...props} title={id ? `${l10n.EDIT} ${l10n.STORY}` : `${l10n.CREATE} ${l10n.STORY}`}>
            <Form
              attributes={FORMS.STORY}
              value={dataSource}
              onChange={_onFormChange}
              onValid={_onFormValid}
              style={STYLE.dialogForm}
            />
            <View style={STYLE.actions}>
              { id && (
                <Fragment>
                  <Button
                    {...isBusy}
                    contained={false}
                    onPress={() => _onSubmit(C.HTTP.METHOD.POST)}
                    disabled
                    title={l10n.CLONE}
                  />
                  <Button
                    {...isBusy}
                    contained={false}
                    onPress={() => _onSubmit(C.HTTP.METHOD.DELETE)}
                    title={l10n.DELETE}
                  />
                </Fragment>)}
              <View style={STYLE.actionSeparator} />
              <Button
                disabled={!valid}
                {...isBusy}
                onPress={() => _onSubmit(C.HTTP.METHOD.UPDATE)}
                primary
                title={id ? l10n.EDIT : l10n.CREATE}
              />
            </View>
          </Dialog>
        )}

      </Consumer>
    );
  }
}

export default DialogStory;
